/**
 * en-GB messages added by Phase 1 task W8 (connecting the portal pages to the real shared code and server).
 * Only that task edits this file. Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w8EnGB = {
    // Agreements: why sealing failed (the server's errorKey is translated and put into this sentence)
    'agreementsUi.sealError': 'Sealing did not finish: {reason}',
    // One question drawn from the shared field-type registry (Today sign-in dialog, member form)
    'fieldInput.choose': 'Choose',
    'fieldInput.change': 'Change',
    'fieldInput.chosen': '{label}: {name}',
    'fieldInput.memberHint': 'Type at least two letters of their name.',
    'fieldInput.memberResults': 'People found for {label}',
    'fieldInput.signaturePad': 'Draw your signature: {label}',
    'fieldInput.signatureSave': 'Save signature',
    'fieldInput.signatureClear': 'Clear',
    'fieldInput.signatureSaved': 'Signature saved.',
    'fieldInput.signatureFailed': 'The signature could not be saved. Please try again.',
    'fieldInput.signatureAtKiosk': 'A signature is drawn on a kiosk, so it cannot be collected here.',
};
//# sourceMappingURL=w8.js.map